var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.704,
    height: 19.057,
    viewBox: "0 0 12.704 19.057",
    fill: "#212547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520",
    transform: "translate(-1813.492 -344.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smartphone_4_",
    "data-name": "smartphone (4)",
    transform: "translate(1809.492 344.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M14.521,0H6.184A2.185,2.185,0,0,0,4,2.184V16.873a2.185,2.185,0,0,0,2.184,2.184h8.337A2.185,2.185,0,0,0,16.7,16.873V2.184A2.185,2.185,0,0,0,14.521,0Zm.6,16.675a.794.794,0,0,1-.794.794H6.382a.794.794,0,0,1-.794-.794V2.382a.794.794,0,0,1,.794-.794h.4a.794.794,0,0,1,.794.794.794.794,0,0,0,.794.794h3.97a.794.794,0,0,0,.794-.794.794.794,0,0,1,.794-.794h.4a.794.794,0,0,1,.794.794Z",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_10",
    "data-name": "Polygon 10",
    d: "M3,0,6,5H0Z",
    transform: "translate(1822.5 352.5) rotate(90)",
    fill: "current"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.908c1db0164f7a7d09d044a7c1dc48aa.svg";
export { ForwardRef as ReactComponent };